import { render, staticRenderFns } from "./FinishReasons.vue?vue&type=template&id=4f30666d"
import script from "./FinishReasons.vue?vue&type=script&lang=js"
export * from "./FinishReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports